import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../styled/flexbox.styled"

export const ExposureGridContainer = styled(FlexContainer)({
  width: "100%",
  height: "100%",
})

export const ExposureGridHeader = styled(FlexContainer)({
  padding: "10px",
  borderBottom: "1px solid #444",
  minHeight: "50px",
})
